import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { Dropdown } from 'primereact/dropdown';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import branchManagerStyles from "../../../styles/branchManager/branchManager.module.css";
import { useDispatch, useSelector } from "react-redux";
//import DatePicker from 'react-datepicker';
//import 'react-datepicker/dist/react-datepicker.css';
//import branchDashBoardDataClient from '../../../utility/features/api_clients/appointment/getBranchDashBoardData'
import getBranchDashBoardData from '../../../utility/features/api_clients/reports/getBranchDashBoardData';
import apptDashboardDataClient from '../../../utility/features/api_clients/appointment/getApptDashboardData';
import BranchDetailsModal from './branchDetailsModal';
import {setAppointmentData, setDateRange, setActivePaginationPage, setBranchAppointmentDetails} from '../../../reduxStore/appointment/appointmentSlice'
import {isEmpty} from "../../../utility/helpers/common";
import { set } from 'react-hook-form';
import ViewAppointmentModal from './viewAppointmentModal';

const Appointments = () => {
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.login);
    let branchList = []
    if (userDetails?.branches && userDetails?.branches.length > 0) {
        // branchList = userDetails.branches;
        branchList = userDetails.branches.map((branch) => ({ label: `${branch.branchID} - ${branch.branchName}`, value : branch.branchID, branchID : branch.branchID, branchName : branch.branchName}));
    }
    const { data:appointmentList, hasUpdated: appointmentHasUpdated, selectedFromDate, selectedToDate, activePaginationPage } = useSelector((state) => state.appointment);
    const [appointments, setAppointments] = useState(appointmentList);
    const [errorMessage, setErrorMessage] = useState("");
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [postalCodes, setPostalCodes] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [branchInfo, setBranchInfo] = useState({});
    const [appointmentViewDetails, setAppointmentViewDetails] = useState({});
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedBranchName, setSelectedBranchName] = useState("");
    const appointmentDetails = useSelector((state) => state.appointment.branchAppointmentDetails);

    // Initialize selectedBranch based on branchList length
    useEffect(() => {
        if (branchList.length === 1) {
            setSelectedBranch(branchList[0].branchID);
            setSelectedBranchName(branchList[0].branchName || "");
        } else if (branchList.length > 1 && !selectedBranch) {
            setSelectedBranch(null);
            setSelectedBranchName("");
            setAppointments([]);
        }
    }, []);

    // useEffect(() => {
    //     initialInfoLoad();
    // }, [branchList])

    // const initialInfoLoad = () => {
        
    // }
    
    // Calculate max date for end date (7 days from start date)
    const getMaxEndDate = () => {
        if (!startDate) return null;
        const maxDate = new Date(startDate);
        maxDate.setDate(maxDate.getDate() + 6);
        return maxDate;
    };

    const dateOnly = (date = new Date()) => {
        return new Date(date).toISOString().split('T')[0];
    }

    const [startDate, setStartDate] = useState(selectedFromDate != "" ? selectedFromDate : new Date());
    const [endDate, setEndDate] = useState(selectedToDate != "" ? selectedToDate : getMaxEndDate());

    const fetchBranchData = async () => {
        setErrorMessage("");
        

        try {
            const result = await apptDashboardDataClient(selectedBranch);
            if (result ?.status !== 200) {
                setErrorMessage("Appointment Scheduler dashboard data fetch failed. Please try again.");
                return;
            }

            const { status, data } = result ?? {};

            if (status === 200 && data ?.messageCode !== 20000) {
                dispatch(setBranchAppointmentDetails(data[0] || null));
            } else if (data.messageCode === 20000) {
                setErrorMessage(data.message || "No Appointment Data Available for the selected criteria.");
                dispatch(setBranchAppointmentDetails(null));
                console.log("Error calling appointment scheduler dashboad data api :", data.message);
            } else {
                setErrorMessage(data.message || "Unexpected response from server.");
            }
        }
        catch (err) {
            console.error("Error logging in:", err);
        } finally {
           
        }
    }

    const fetchBranchDashBoardData = async () => {
        const payload = {
            "branchID": parseInt(selectedBranch),
            "postalCodeID":"", 
            "startDate": dateOnly(startDate), 
            "endDate": dateOnly(endDate)
        };
        dispatch(setDateRange({
            selectedFromDate: startDate,
            selectedToDate: endDate
        }));
        
        setErrorMessage("");

        try {
            const result = await getBranchDashBoardData(payload);

            if (result?.status !== 200) {
                setErrorMessage("Branch dashboard data fetch failed. Please try again.");
                return;
            }

            const { status, data } = result ?? {};

            if (status === 200 && data?.messageCode !== 20000) {
                setAppointments(data);
                dispatch(setAppointmentData(data));
            } else if (data.messageCode === 20000) {
                setErrorMessage(data.message || "No Appointment Data Available for the selected criteria.");
                setAppointments([]);
                console.log("Error calling branch dashboad data api :", data.message);
            } else {
                setErrorMessage(data.message || "Unexpected response from server.");
            }
        }
        catch (err) {
            console.error("Error logging in:", err);
        } finally {
           
        }
    }

    useEffect(() => {
        if(appointments.length == 0 && selectedBranch){
            (async () => {
                setLoadingSearch(true);
                await fetchBranchData();
                await fetchBranchDashBoardData();
                setLoadingSearch(false);
            })();
        }
    }, [startDate, endDate, selectedBranch]);

    useEffect(() => {
        if(appointmentHasUpdated){
            (async () => {
                await fetchBranchDashBoardData();
            })();
        }
    }, [appointmentHasUpdated]);

    // Filter dates for end date picker
    const filterEndDate = (date) => {
        if (!startDate) return false;
        const maxDate = getMaxEndDate();
        return date > startDate && date <= maxDate;
    };

    // Handle start date change
    const handleStartDateChange = (date) => {
        setStartDate(date);
        // Reset end date if it's outside the new valid range
        if (endDate) {
            const maxDate = new Date(date);
            maxDate.setDate(maxDate.getDate() + 7);
            if (endDate <= date || endDate > maxDate) {
                setEndDate(null);
            }
        }
    };

    // Filter appointments based on search term
    const filteredBranchSummary = appointments;
   
    const [activePage, setActivePage] = useState(activePaginationPage);
    const ITEMS_PER_PAGE = 10;
    const totalPages = Math.ceil(filteredBranchSummary?.length / ITEMS_PER_PAGE);
    const startIndex = (activePage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedAppointments = filteredBranchSummary?.slice(startIndex, endIndex);

    const handlePageClick = (pageNum) => {
        setActivePage(pageNum);
        dispatch(setActivePaginationPage(pageNum));
    };

    const handleSearch = async () => {
        await fetchBranchDashBoardData();
        setActivePage(1); // Reset to first page on search
        dispatch(setActivePaginationPage(1));
    };
    const handleBranchInfoClick = () => {
        //  show branch info modal
        const branchInfo = {
            branchID: selectedBranch,
            branchName: selectedBranchName
        };
        setBranchInfo(branchInfo);
        setIsModalOpen(true);
    }
    const closeModal = () => {
        setIsModalOpen(false);
    }

    const handleViewAppointmentModal = (branch) => {  
        setAppointmentViewDetails(branch);
    }

    return (
        <>
            {/* <h3 class="mb-3">{!isEmpty(selectedBranchName) && `Welcome to ${selectedBranchName || userDetails?.branchName} branch`}</h3> */}
            {!isEmpty(selectedBranchName) ? 
                <h3 class="mb-3">{`Welcome to ${selectedBranchName || userDetails?.branchName} branch`}</h3> 
                : <h6 class="form-label">{`Select a branch from dropdown to continue*`}</h6> 
            }
            <div className="container p-0">
                <div className="row position-relative d-flex justify-content-between align-items-center">
                    {errorMessage && <div className="col-12">
                        <div className="alert alert-danger d-flex gap-3 vh-2" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" viewBox="0 0 16 16" className="">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                            </svg>
                            <h5 >{errorMessage}</h5>
                        </div>
                    </div>}
                    {appointmentDetails && appointmentDetails.isBranchEnabled == false && selectedBranch && <div className="col-12">
                        <div className="alert alert-info text-center" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" className="mb-3">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                            </svg>
                            <h5>{`Branch is currently inactive`}</h5>
                            <p className="mb-0">You will not able to reschedule.</p>
                        </div>
                    </div>}
                </div>
                {branchList.length > 1 && (
                    <div className='row py-2'>
                        <div className='col-12 col-md-3 mb-2 mb-md-0'>
                            {/* <label className='form-label'>Select Branch*</label> */}
                            <Dropdown value={selectedBranch} 
                            onChange={(e) => { 
                                    const selectedBranchId = parseInt(e.value);
                                    const branch = userDetails.branches.find(b => b.branchID === selectedBranchId);
                                    setSelectedBranch(selectedBranchId);
                                    setSelectedBranchName(branch?.branchName || "");
                                    setAppointments([]);
                                    dispatch(setActivePaginationPage(1))
                                }} 
                                options={branchList}
                                placeholder="Choose a Branch" className="w-full md:w-14rem" />
                            {/* <select 
                                className='form-control'
                                value={selectedBranch || ''}
                                onChange={(e) => {
                                    const selectedBranchId = parseInt(e.target.value);
                                    const branch = branchList.find(b => b.branchID === selectedBranchId);
                                    setSelectedBranch(selectedBranchId);
                                    setSelectedBranchName(branch?.branchName || "");
                                    setAppointments([]);
                                    dispatch(setActivePaginationPage(1));
                                }}
                            >
                                <option value="">Choose a branch</option>
                                {branchList.map((branch) => (
                                    <option key={branch.branchID} value={branch.branchID}>
                                        {branch.branchID} - {branch.branchName}
                                    </option>
                                ))}
                            </select> */}
                        </div>
                    </div>
                )}
                <div className='row py-2'>
                    <div className='col-12 col-md-3 mb-2 mb-md-0'>
                        <label className='form-label w-50'>Branch Id : <strong>{selectedBranch || userDetails?.branchID || 'N/A'}</strong></label>
                    </div>
                    <div className='col-12 col-md-3 mb-2 mb-md-0'>
                        <label className='form-label'>Branch Name : <strong>{selectedBranchName || userDetails?.branchName || 'N/A'}</strong></label>
                    </div>
                    <div className='col-12 col-md-3 mb-2 mb-md-0'>
                        <label data-bs-toggle="modal" data-bs-target="#BranchDetailsModal" role="button" 
                        tabIndex="0" className='form-label'>For Branch Info <a style={{color:'blue', textDecoration:'underline', cursor:'pointer'}} onClick={handleBranchInfoClick}>Click here</a></label>
                    </div>
                    {/*<div className='col-12 col-md-2 mb-2 mb-md-0'>
                        <label className='form-label'>Start Date</label>
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                            className='form-control'
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Select start date"
                            showIcon
                            toggleCalendarOnIconClick
                        />
                    </div>
                    <div className='col-12 col-md-2 mb-2 mb-md-0'>
                        <label className='form-label'>End Date</label>
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            className='form-control'
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Select end date"
                            disabled={!startDate}
                            filterDate={filterEndDate}
                            minDate={startDate ? new Date(startDate.getTime() + 86400000) : null}
                            maxDate={getMaxEndDate()}
                            showIcon
                            toggleCalendarOnIconClick
                        />
                    </div>
                    <div className='col-12 col-md-2 mb-2 mb-md-0'>
                        <label className='form-label'>&nbsp;</label>
                        <button
                            type="button"
                            className={`btn btn-primary w-100 ${branchManagerStyles["bg-green"]}`}
                            onClick={handleSearch}
                        >
                            Search
                        </button>
                    </div>
                    */}
                </div>


                {/* </div> */}

                <div className={branchManagerStyles["table-theme"]}>
                    <div className={`table-responsive ${branchManagerStyles["table-card"]}`}>
                        <table className={`w-100 ${branchManagerStyles["table"]} align-middle`}>
                            <thead>
                                <tr>
                                    <th scope="col" style={{width:"100px"}}>Branch Id</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Address</th>
                                    <th scope="col">Appt Date - Time - Type</th>
                                    {/* <th scope="col">Appt Time</th> */}
                                    {/* <th scope="col">Type</th> */}
                                    <th scope="col">Phone Num</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {loadingSearch ? (
                                <tr>
                                    <td colSpan="7" className="text-center py-4">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <div className="mt-2">Loading data...</div>
                                    </td>
                                </tr>
                            ) : paginatedAppointments.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center py-4">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                paginatedAppointments.map((branch, idx) => {
                                    return (
                                        <tr key={branch?.branchID}>
                                            <td>{branch?.branchID}</td>
                                            <td>{branch?.name}</td>
                                            <td>{branch?.email}</td>
                                            <td style={{width:"200px"}}>{branch?.address}</td>
                                            <td  scope="col" className='d-flex flex-column '>
                                                <span>{branch?.appointmentDate} - {branch?.appointmentTime} ({branch?.appoinmentType})</span>
                                            </td>
                                            <td>{branch?.customerPhone}</td>
                                            <td className='text-center'>
                                                <Link className={`btn btn-sm ${branchManagerStyles['btn-outline-accent']} ${appointmentDetails?.isBranchEnabled?'':'disabled'} ${branch.isReschedulable?'':'disabled'}`} to={appointmentDetails?.isBranchEnabled?`/configure/branch-manager/reschedule/${branch?.postalcode}/${branch?.userRecordID}`:''}>Reschedule</Link>
                                                <button className={`btn btn-sm ${branchManagerStyles['btn-outline-accent']} py-2 mt-10 ml-2`} type="button"
                                                        data-bs-toggle="modal" data-bs-target="#viewBranchModal" onClick={() => handleViewAppointmentModal(branch)}>
                                                        View
                                                    </button>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="row py-2">
                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className={branchManagerStyles['pagination']}>
                            {activePage > 1 && (
                                <button className={`${branchManagerStyles["page-btn"]} ${branchManagerStyles['next-btn']}`} onClick={() => handlePageClick(activePage - 1)}>
                                    &lt;
                                </button>
                            )}
                            {activePage > 3 && (
                                <>
                                    <button className={branchManagerStyles["page-btn"]} onClick={() => handlePageClick(1)}>
                                        1
                                    </button>
                                    {activePage > 4 && <span className={branchManagerStyles["ellipsis"]}>...</span>}
                                </>
                            )}

                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter((num) => num >= activePage - 2 && num <= activePage + 2)
                                .map((num) => (
                                    <button
                                        key={num}
                                        className={`${branchManagerStyles["page-btn"]} ${num === activePage ? branchManagerStyles["active"] : ""}`}
                                        onClick={() => handlePageClick(num)}
                                    >
                                        {num}
                                    </button>
                                ))}
                            {activePage < totalPages - 2 && (
                                <>
                                    {activePage < totalPages - 3 && <span className={branchManagerStyles["ellipsis"]}>...</span>}
                                    <button className={branchManagerStyles["page-btn"]} onClick={() => handlePageClick(totalPages)}>
                                        {totalPages}
                                    </button>
                                </>
                            )}
                            {activePage < totalPages && (
                                <button className={`${branchManagerStyles["page-btn"]} ${branchManagerStyles['next-btn']}`} onClick={() => handlePageClick(activePage + 1)}>
                                    &gt;
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <BranchDetailsModal branchDetails={branchInfo} isOpen={true} onClose={closeModal} />
            <ViewAppointmentModal appointmentDetails={appointmentViewDetails} />
        </>
    );
};


export default Appointments;